import React from 'react';

import { ReportTypeID, reportTypeIDToPillTKey } from '~/src/dash/apiV2/reporting/reportTypes';
import {
  borderRadius,
  Col,
  Cols,
  ISimpleOptionSelect,
  spacingV2,
  Text,
} from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface IQuickReportOptionSelect extends ISimpleOptionSelect {
  description: string;
}

interface IQuickReportsSelectorProps {
  options: IQuickReportOptionSelect[];
  onChange: (id: string) => void;
}

export const QuickReportSelector = ({ options, onChange }: IQuickReportsSelectorProps) => {
  const sortQuickReportOptions = (
    options: IQuickReportOptionSelect[],
  ): IQuickReportOptionSelect[] => {
    const QUICK_REPORT_TYPES_IN_ORDER = [
      ReportTypeID.AuctionQuickReport,
      ReportTypeID.BidderQuickReport,
      ReportTypeID.CampaignQuickReport,
      ReportTypeID.AdomainQuickReport,
      ReportTypeID.ContentQuickReport,
      ReportTypeID.AppBundleQuickReport,
    ];

    return QUICK_REPORT_TYPES_IN_ORDER.map((quickReportID) =>
      options.find((option) => +option.value === quickReportID),
    ) as IQuickReportOptionSelect[];
  };

  const sortedOptions = sortQuickReportOptions(options);

  return (
    <Cols gap='1rem' wrap>
      {sortedOptions.map((option) => {
        return (
          <Col
            extraSmallVerticalPadding
            horizontalPadding
            onClick={() => {
              onChange(option.value);
            }}
            style={{
              marginTop: spacingV2.extraSmall, // for spacing once this wraps
              border: `1px solid ${publicaColors.lightGray}`,
              borderRadius: borderRadius.base,
              backgroundColor: option.isSelected ? publicaColors.lighterBlue : 'inherit',
              cursor: 'pointer',
            }}
          >
            <Text
              tKey={reportTypeIDToPillTKey[option.value]}
              disableSelect
              small
              bold={option.isSelected}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
